import _ from 'lodash'

export const titleCase = text =>
  text.replace(
    /\w\S*/g,
    txt => `${txt.charAt(0).toUpperCase()}${txt.substr(1).toLowerCase()}`
  )

export const onlyNumbers = value => {
  if (value && typeof value === 'string') {
    return value.replace(/[^0-9,.]/g, '')
  }
  return value
}

export const capitalizeWords = (string, regEx) => {
  // Accepts string
  const words = _.words(string, regEx)
  const capitalizedWords = words.map(w => _.capitalize(w))
  // Returns array of words in capitalized format. Use Array.join()
  return capitalizedWords
}

export const capitalizeSentence = (string, regEx = /[^ ]+/g) => {
  // Accepts string
  const words = _.words(string, regEx)
  const capitalizedWords = words.map(w => _.capitalize(w))
  // Returns array of words in capitalized format. Use Array.join()
  return capitalizedWords.join(' ')
}
